import { api } from '@signiapp/helpers';
var BASE_PATH = '/demonode';

var req = function req(url, options) {
  return api.req("".concat(window.SIGNIAPP_IS_LOCAL ? 'http://localhost:3000' : BASE_PATH).concat(url), options);
};

export var getHello = function getHello() {
  return req('/hello');
};
export default {
  getHello: getHello
};